export const useOmitSubmissionStepsByPermissions = (userPermissions = {}) => {
  const {
    BUDGET_STEP,
    GENERAL_INFO_STEP,
    TECHNICAL_STEP,
    PARTICIPANT_STEP,
    SUSTAINABILITY_STEP,
    SCHEDULING_STEP,
    RESOURCES_STEP,
    COMMENTS_STEP
  } = userPermissions
    ?.SUBMISSIONS
    ?.ALL_SUBMISSIONS_PAGE
    ?.SUBMISSION_EDIT_PAGE || {}

  const stepsMapByPermission = {
    "general-information": !!GENERAL_INFO_STEP,
    "technical-specs": !!TECHNICAL_STEP,
    "participant-form":!!PARTICIPANT_STEP,
    "sustainability": !!SUSTAINABILITY_STEP,
    "budget": !!BUDGET_STEP,
    "timetable": !!SCHEDULING_STEP,
    "human-resources": !!RESOURCES_STEP,
    "comments": !!COMMENTS_STEP
  }

  return Object
    .entries(stepsMapByPermission)
    .reduce((acc, [permissionKey, hasPermission]) => {
      if (!hasPermission)
        acc.push(permissionKey)

      return acc
    }, [])
}
